export default "__VITE_PUBLIC_ASSET__fa1e4bd2__"